"use client";

import { useState } from "react";
import { forumPath } from "./ForumService";
import { useRouter, useSearchParams } from "next/navigation";
import { Search } from "lucide-react";

// Search the floor from the CRM tab. Plain form → /forum/search?q= so a
// query is a URL you can share or come back to.
export function ForumSearchBox({ className = "" }: { className?: string }) {
  const router = useRouter();
  const params = useSearchParams();
  const [q, setQ] = useState(params.get("q") || "");
  return (
    <form
      role="search"
      onSubmit={(e) => {
        e.preventDefault();
        const term = q.trim();
        if (term.length >= 2) router.push(forumPath(`/search?q=${encodeURIComponent(term)}`));
      }}
      className={`flex h-9 items-center gap-2 rounded-md border bg-card px-3 transition-colors focus-within:border-primary/60 focus-within:ring-2 focus-within:ring-primary/20 ${className}`}
    >
      <Search className="h-4 w-4 shrink-0 text-muted-foreground" />
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder="Search the floor"
        aria-label="Search the floor"
        className="w-full min-w-0 bg-transparent text-[13px] outline-none placeholder:text-muted-foreground"
      />
    </form>
  );
}
